import { Emitter, type Event } from '@patsnap/tahiti-core';

export type ChatInputRequiredSource =
    | 'waiting'
    | 'tool_result'
    | 'instruction_form'
    | 'template_section_form';

export interface ChatInputRequiredEvent {
    source: ChatInputRequiredSource;
    timestamp: string;
    conversationId?: string;
    toolCallId?: string;
    toolName?: string;
    turnId?: string;
    status?: string;
}

export interface QaOnlyWriteBlockedEvent {
    actionId: string;
    conversationId: string;
    turnId?: string;
    toolName: string;
    code: string;
}

export interface ChatEventSource {
    readonly onInputRequired: Event<ChatInputRequiredEvent>;
    readonly onQaOnlyWriteBlocked: Event<QaOnlyWriteBlockedEvent>;
}

export interface ChatEventPublisher {
    /** 发布当前对话需要用户输入的事实。 */
    publishInputRequired(event: ChatInputRequiredEvent): void;
    /** 发布 QA-only 阻止文档写入、需要用户确认的事实。 */
    publishQaOnlyWriteBlocked(event: QaOnlyWriteBlockedEvent): void;
}

/** 创建可隔离测试的聊天领域事件服务。 */
export function createChatEvents(): ChatEventSource & ChatEventPublisher {
    const inputRequiredEmitter = new Emitter<ChatInputRequiredEvent>({
        onListenerError: error => console.error('[ChatEvents] listener failed:', error),
    });
    const qaOnlyWriteBlockedEmitter = new Emitter<QaOnlyWriteBlockedEvent>({
        onListenerError: error => console.error('[ChatEvents] listener failed:', error),
    });
    return {
        onInputRequired: inputRequiredEmitter.event,
        publishInputRequired: event => inputRequiredEmitter.fire(event),
        onQaOnlyWriteBlocked: qaOnlyWriteBlockedEmitter.event,
        publishQaOnlyWriteBlocked: event => qaOnlyWriteBlockedEmitter.fire(event),
    };
}

/** 应用级聊天领域事件服务。 */
export const chatEvents = createChatEvents();
